/**
 * @generated SignedSource<<7f86b56c7b201279f0bc996673e03107>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CityEditForm_city$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "CityEditForm_city";
};
export type CityEditForm_city$key = {
  readonly " $data"?: CityEditForm_city$data;
  readonly " $fragmentSpreads": FragmentRefs<"CityEditForm_city">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityEditForm_city",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "City",
  "abstractKey": null
};

(node as any).hash = "3588c53f754fe8089d5aa42a96491ed1";

export default node;
